var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgAide = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25.907,
    height: 25.907,
    viewBox: "0 0 25.907 25.907",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "aide",
    transform: "translate(-668.093 -102.093)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_906794",
    "data-name": 906794,
    transform: "translate(668.093 102.093)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_39",
    "data-name": "Groupe 39"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_38",
    "data-name": "Groupe 38"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1",
    "data-name": "Ellipse 1",
    cx: 1.265,
    cy: 1.265,
    r: 1.265,
    transform: "translate(11.688 17.887)",
    fill: "#5471a9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_29",
    "data-name": "Trac\\xE9 29",
    d: "M12.953,0A12.953,12.953,0,1,0,25.907,12.953,12.946,12.946,0,0,0,12.953,0Zm0,23.883A10.929,10.929,0,1,1,23.883,12.953,10.923,10.923,0,0,1,12.953,23.883Z",
    fill: "#5471a9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_30",
    "data-name": "Trac\\xE9 30",
    d: "M180.048,128.5A4.052,4.052,0,0,0,176,132.548a1.012,1.012,0,1,0,2.024,0,2.024,2.024,0,1,1,2.024,2.024,1.012,1.012,0,0,0-1.012,1.012v2.53a1.012,1.012,0,0,0,2.024,0v-1.646a4.048,4.048,0,0,0-1.012-7.968Z",
    transform: "translate(-167.095 -121.998)",
    fill: "#5471a9"
  })))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgAide, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/aide.d74c1b38.svg";
export { ForwardRef as ReactComponent };